import { render, staticRenderFns } from "./TermsPage.vue?vue&type=template&id=ce2ef36c"
import script from "./TermsPage.vue?vue&type=script&lang=js"
export * from "./TermsPage.vue?vue&type=script&lang=js"
import style0 from "./TermsPage.vue?vue&type=style&index=0&id=ce2ef36c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports